import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";

export interface TrioPermission {
  id: string;
  displayName: string;
  name: string;
  category: string;
  subCategory: string;
}

export interface TrioRole {
  id: string;
  name: string;
  description: string;
  companyId?: string;
  employeesCount?: number;
  permissions: TrioPermission[];
  icon?: string;
}

export const useGetRoles = () => {
  return useQuery({
    queryFn: () =>
      MyAxios.get<TrioRole[]>("/acl/roles", {}).then((res) => res.data),
    queryKey: ["Roles"],
  });
};
